// src/App.js
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/Home";
import SecondPage from "./pages/SecondPage";
import OrderList from "./pages/OrderList";
import Login from "./pages/Login";
import CustomerCost from "./pages/CustomerCost";
import SalesPersonCost from "./pages/SalesPersonCost";

function AppWrapper() {
  const location = useLocation();
  const hideNavFooter = location.pathname === "/login";

  return (
    <>
      {!hideNavFooter && <Navbar />}

      <div className="mainContent">
        <Routes>
          {/* Public */}
          <Route path="/login" element={<Login />} />

          {/* Protected */}
          <Route
            path="/"
            element={
              // <ProtectedRoute>
              <Home />
              // </ProtectedRoute>
            }
          />
          <Route
            path="/second"
            element={
              // <ProtectedRoute>
              <SecondPage />
              // </ProtectedRoute>
            }
          />
          <Route
            path="/orders"
            element={
              // <ProtectedRoute>
              <OrderList />
              // </ProtectedRoute>
            }
          />
          <Route path="/customer-cost" element={<CustomerCost />} />
          <Route path="/salesperson-cost" element={<SalesPersonCost />} />
        </Routes>
      </div>

      {!hideNavFooter && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}
